import repairImg from '../components/repair/three.jpg'
import electricImg from '../components/repair/four.jpg'
import plumbingUrl from '../components/plumbing/plumber1.jpg'


export const infoData = [
    {
        id: 1,
        heading: "Convient Location",
        text: "Conveniently located at the heart of the city, KM Electrical Construction Company ensures easy accessibility for clients seeking reliable electrical services. ",
        btnText: "Our Location",
        link: "/contact-us",
        imgUrl: repairImg
    },
    {
        id: 2,
        heading: "Multitude of Services",
        text: "With a diverse portfolio of over 10 services, KM Electrical Construction Company offers a multitude of solutions tailored to meet the unique needs of our clients. From fault diagnosis and maintenance to compliance testing and HV equipment servicing, we provide comprehensive electrical services to ensure optimal functionality and safety across various sectors.",
        btnText: "Our Services",
        link: "/services",
        imgUrl: electricImg
    },
    {
        id: 3,
        heading: "KM Classic Short Circuit",
        text: "At KM Classic Short Circuit, we pride ourselves on being a leading provider of electrical solutions with a rich history of excellence. With a commitment to quality craftsmanship and customer satisfaction, our team of skilled professionals strives to exceed expectations in every project we undertake.",
        btnText: "About Us",
        link: "/about-us",
        imgUrl: plumbingUrl
    },
]